/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingFrequency } from './BillingFrequency';
import {
    BillingFrequencyFromJSON,
    BillingFrequencyFromJSONTyped,
    BillingFrequencyToJSON,
    BillingFrequencyToJSONTyped,
} from './BillingFrequency';

/**
 * 
 * @export
 * @interface CreateCalculationCycleRequest
 */
export interface CreateCalculationCycleRequest {
    /**
     * 
     * @type {Date}
     * @memberof CreateCalculationCycleRequest
     */
    cycleDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateCalculationCycleRequest
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateCalculationCycleRequest
     */
    endDate: Date;
    /**
     * 
     * @type {BillingFrequency}
     * @memberof CreateCalculationCycleRequest
     */
    billingFrequency: BillingFrequency;
    /**
     * 
     * @type {string}
     * @memberof CreateCalculationCycleRequest
     */
    description?: string | null;
}



/**
 * Check if a given object implements the CreateCalculationCycleRequest interface.
 */
export function instanceOfCreateCalculationCycleRequest(value: object): value is CreateCalculationCycleRequest {
    if (!('cycleDate' in value) || value['cycleDate'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('billingFrequency' in value) || value['billingFrequency'] === undefined) return false;
    return true;
}

export function CreateCalculationCycleRequestFromJSON(json: any): CreateCalculationCycleRequest {
    return CreateCalculationCycleRequestFromJSONTyped(json, false);
}

export function CreateCalculationCycleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCalculationCycleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'cycleDate': (new Date(json['cycleDate'])),
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'billingFrequency': BillingFrequencyFromJSON(json['billingFrequency']),
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateCalculationCycleRequestToJSON(json: any): CreateCalculationCycleRequest {
    return CreateCalculationCycleRequestToJSONTyped(json, false);
}

export function CreateCalculationCycleRequestToJSONTyped(value?: CreateCalculationCycleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cycleDate': value['cycleDate'].toISOString().substring(0,10),
        'startDate': value['startDate'].toISOString().substring(0,10),
        'endDate': value['endDate'].toISOString().substring(0,10),
        'billingFrequency': BillingFrequencyToJSON(value['billingFrequency']),
        'description': value['description'],
    };
}

